export function selectTheme() {
    let theme = process.env.REACT_APP_THEME?.toString();
    return import(`./theme/${theme}/theme.scss`);
}
